<!-- <mat-toolbar class="app-header mat-elevation-z3 flex-gap-10" color="primary"> -->
<mat-toolbar class="flex-gap-10" color="primary" [class]="prod ? 'app-header mat-elevation-z3 prod' : 'app-header mat-elevation-z3 devel'">

  <button mat-icon-button type="button" (click)="sidenav().opened = !sidenav().opened" aria-label="Meniu"
    [attr.aria-expanded]="sidenav().opened">
    <mat-icon>menu</mat-icon>
  </button>
  @if (currentUser(); as currentUser) {
    <button mat-button [routerLink]="'/'">@if (!prod) {
      <span>SITE TEST - </span>
      } <span>C.M. {{
    currentUser.judet_id | judet}}</span></button>
  }
  @if (medic(); as medic) {
    @if (isMedicSelected()) {
      <app-nav-medic [medic]="medic" />
    }
  }
  <span class="flex-auto"></span>
  <app-nav-notificari />
  <app-nav-user />

</mat-toolbar>